module.exports = __webpack_public_path__ + "img/pin.00c9b379.png";